<footer class="container">
  <p class="float-right"><a (click)="backToTop()" style="cursor: pointer">Back to top</a></p>
  <p>&copy; 2017-{{ currentYear() }} <a href="https://www.withinweb.com">WithinWeb.com</a></p>
</footer>
